const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJpgSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32x",
    height: "32px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.188 318.188",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8E8E8"
    },
    points: "227.321,7.5 40.342,7.5 40.342,310.688 277.846,310.688 277.846,58.025  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 98.402,
    y: 69.204,
    style: {
      fill: "#38A3FF"
    },
    width: 119.89,
    height: 119.89
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#007934"
    },
    points: "192.295,130.178 168.483,170.358 129.743,104.984 98.402,157.872 98.402,189.093  218.292,189.093 218.292,174.049  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#38A3FF"
    },
    points: "235.14,32.763 40.342,32.763 40.342,7.5 227.321,7.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1D3D3"
    },
    points: "227.321,58.025 277.846,58.025 227.321,7.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333E48"
    },
    d: "M105.856,277.794c0,3.129-0.459,5.338-1.378,6.629s-2.451,1.936-4.594,1.936 c-0.919,0-1.772-0.082-2.56-0.246s-1.531-0.312-2.231-0.443v10.075c2.123,0.459,4.365,0.689,6.728,0.689 c5.688,0,9.955-1.669,12.799-5.005c2.844-3.336,4.266-8.253,4.266-14.751v-43.287h-13.028v44.403H105.856z M159.513,237.363 c-3.041-2.647-7.592-3.971-13.652-3.971h-16.606v47.979h12.963v-15.917h3.643c5.82,0,10.31-1.46,13.472-4.381 c3.16-2.92,4.742-7.061,4.742-12.421C164.075,243.773,162.554,240.01,159.513,237.363z M149.224,253.247 c-1.148,1.094-2.695,1.641-4.643,1.641h-2.363v-11.026h3.348c3.588,0,5.383,1.619,5.383,4.857 C150.948,250.643,150.374,252.153,149.224,253.247z M190.984,263.289h8.565v7.515c-1.619,0.373-3.392,0.558-5.316,0.558 c-3.523,0-6.219-1.176-8.09-3.528c-1.87-2.352-2.806-5.771-2.806-10.256c0-4.572,1.033-8.089,3.102-10.551 c2.067-2.461,4.993-3.692,8.778-3.692c4.135,0,7.931,0.854,11.388,2.56l4.103-10.174c-1.991-0.875-4.327-1.597-7.007-2.166 c-2.681-0.568-5.53-0.853-8.549-0.853c-7.964,0-14.156,2.155-18.575,6.465c-4.419,4.311-6.629,10.338-6.629,18.083 c0,7.942,2.019,14.058,6.055,18.345c4.037,4.288,9.752,6.432,17.147,6.432c6.738,0,12.919-0.962,18.542-2.888v-25.86h-20.708 L190.984,263.289L190.984,263.289z M283.149,52.722L232.625,2.197C231.218,0.79,229.311,0,227.321,0H40.342 c-4.142,0-7.5,3.358-7.5,7.5v303.188c0,4.142,3.358,7.5,7.5,7.5h237.504c4.143,0,7.5-3.358,7.5-7.5V58.025 C285.346,56.036,284.556,54.129,283.149,52.722z M234.821,25.606l24.918,24.919h-24.918L234.821,25.606L234.821,25.606z M47.842,15 h171.979v10.263H47.842V15z M270.346,303.188H47.842V40.263h171.979v17.763c0,4.142,3.357,7.5,7.5,7.5h43.024v237.662H270.346z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpgSvgrepoCom);
export default __webpack_public_path__ + "static/media/jpg-svgrepo-com.ee1de2fd.svg";
export { ForwardRef as ReactComponent };